// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__8z6rG","label":"Category_label__3HnZH","content":"Category_content__2Ewe9","header":"Category_header__2hg-V","location":"Category_location__2OGe1"};